import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../../Contexts/GlobalContext';



export default function useGuiTranslations(props) {
    const globalContext = useContext(GlobalContext);

    const translations = {
        "0": {
            en: "",    
            tr: "",
        },
        "1": {
            en: "orders",    
            tr: "siparişler",
        },
        "2": {
            en: "open orders",    
            tr: "açık siparişler",
        },
        "3": {
            en: "order History",    
            tr: "geçmiş siparişler",
        },
        "4": {
            en: "menu",    
            tr: "menü",
        },
        "5": {
            en: "categories",    
            tr: "kategoriler",
        },
        "6": {
            en: "food & drinks",    
            tr: "yemekler ve içecekler",
        },
        "7": {
            en: "option groups",    
            tr: "ekstralar",
        },
        "8": {
            en: "settings",    
            tr: "ayarlar",
        },
        "9": {
            en: "payment",    
            tr: "ödeme",
        },
        "10": {
            en: "tables",    
            tr: "masalar",
        },
        "11": {
            en: "restaurant info",    
            tr: "restoran bilgileri",
        },
        "12": {
            en: "deliver & collect",    
            tr: "teslimat biçimleri",
        },
        "13": {
            en: "advanced settings",    
            tr: "gelişmiş ayarlar",
        },
        "14": {
            en: "user",    
            tr: "kullanıcı",
        },
        "15": {
            en: "change password",    
            tr: "sifre degistir",
        },
        "16": {
            en: "sign out",    
            tr: "oturumu kapat",
        },
        "17": {
            en: "remaining days for your trial:",    
            tr: "denemeniz için kalan gün:",
        },
        "18": {
            en: "click to subscribe",    
            tr: "abonelik için klikleyin",
        },
        "19": {
            en: "open customer site",    
            tr: "müşteri sitesini açın",
        },
        "20": {
            en: "no orders yet",    
            tr: "henüz sipariş yok",
        },
        "21": {
            en: "order at table",    
            tr: "masadan sipariş",
        },
        "22": {
            en: "click to collect",    
            tr: "gel al",
        },
        "23": {
            en: "delivery",    
            tr: "teslimat",
        },
        "24": {
            en: "table no",    
            tr: "masa no",
        },
        "25": {
            en: "order no",    
            tr: "sipariş no",
        },
        "26": {
            en: "product",    
            tr: "ürün",
        },
        "27": {
            en: "price",    
            tr: "fiyat",
        },
        "28": {
            en: "served",    
            tr: "servis edildi",
        },
        "29": {
            en: "total",    
            tr: "toplam",
        },
        "30": {
            en: "Order date",    
            tr: "Sipariş tarihi",
        },
        "31": {
            en: "delivery type",    
            tr: "teslimat biçimi",
        },
        "32": {
            en: "time",    
            tr: "saat",
        },
        "33": {
            en: "available",    
            tr: "satışa açık",
        },
        "34": {
            en: "category name",    
            tr: "kategori adı",
        },
        "35": {
            en: "actions",    
            tr: "işlemler",
        },
        "36": {
            en: "food or drink name",    
            tr: "yemek veya içecek ismi",
        },
        "37": {
            en: "description",    
            tr: "tanım",
        },
        "38": {
            en: "description",    
            tr: "tanım",
        },
        "39": {
            en: "product group",    
            tr: "ürün grubu",
        },
        "40": {
            en: "add option group",    
            tr: "ekstra ekle",
        },
        "41": {
            en: "picture",    
            tr: "resim",
        },
        "42": {
            en: "add picture",    
            tr: "resim ekle",
        },
        "43": {
            en: "delete picture",    
            tr: "resim sil",
        },
        "44": {
            en: "cancel",    
            tr: "iptal",
        },
        "45": {
            en: "save",    
            tr: "kaydet",
        },
        "46": {
            en: "option group name",    
            tr: "ekstra grubu adı",
        },
        "47": {
            en: "allow multiples of an option",    
            tr: "ekstrayı 1 kereden fazla ekleyebilsin mi?",
        },
        "48": {
            en: "How many options can the customer choose?",    
            tr: "Müşteri kaç farklı ekstra seçebilir?",
        },
        "49": {
            en: "from",    
            tr: "'dan başlayarak",
        },
        "50": {
            en: "to",    
            tr: "'a kadar",
        },
        "51": {
            en: "options",    
            tr: "ekstralar",
        },
        "52": {
            en: "add option",    
            tr: "ekstra ekle",
        },
        "53": {
            en: "option name",    
            tr: "ekstra adı",
        },
        "54": {
            en: "please fill option group name",    
            tr: "ekstra adı",
        },
        "55": {
            en: "please enter name",    
            tr: "isim girin",
        },
        "56": {
            en: "please enter name",    
            tr: "fiyat girin",
        },
        "57": {
            en: "table name",    
            tr: "masa adı",
        },
        "58": {
            en: "QR Code or URL for",    
            tr: "Kare kod veya URL: ",
        },
        "59": {
            en: "Print QR Code",    
            tr: "Kare kodu yazdır",
        },
        "60": {
            en: "Restaurant name",    
            tr: "Restoran adı",
        },
        "61": {
            en: "Phone number",    
            tr: "Telefon no",
        },
        "62": {
            en: "Language",    
            tr: "Dil",
        },
        "63": {
            en: "Time zone",    
            tr: "Zaman dilimi",
        },
        "64": {
            en: "Logo will be used on customer ordering app with a maximum width of 120 pixels",    
            tr: "Logo müşteri ekranında genişliği 120 piksel olacak şekilde görüntülenecek",
        },
        "65": {
            en: "Change logo",    
            tr: "Logoyu değiştir",
        },
        "66": {
            en: "Restaurant info",    
            tr: "Restoran bilgileri",
        },
        "67": {
            en: "Order at table",    
            tr: "Masadan sipariş",
        },
        "68": {
            en: "Click to collect",    
            tr: "Gel-al sipariş",
        },
        "69": {
            en: "Average time to collect (minutes)",    
            tr: "Gel-al ortalama süresi (dakika)",
        },
        "70": {
            en: "Opening times",    
            tr: "Açık olan saatler",
        },
        "71": {
            en: "open",    
            tr: "açılış",
        },
        "72": {
            en: "close",    
            tr: "kapanış",
        },
        "73": {
            en: "close",    
            tr: "kapanış",
        },

        "74": {
            en: "monday",    
            tr: "pazartesi",
        },
        "75": {
            en: "tuesday",    
            tr: "salı",
        },
        "76": {
            en: "wednesday",    
            tr: "çarşamba",
        },
        "77": {
            en: "thursday",    
            tr: "perşembe",
        },
        "78": {
            en: "friday",    
            tr: "cuma",
        },
        "79": {
            en: "saturday",    
            tr: "cumartesi",
        },
        "80": {
            en: "sunday",    
            tr: "pazar",
        },
        "81": {
            en: "Multi-language",    
            tr: "Çoklu-dil",
        },
        "82": {
            en: "Enable or disable multi-lang on the customer app.",    
            tr: "Çoklu-dil desteğini müşteri uygulaması üzerinde açın veya kapatın.",
        },
        "83": {
            en: "Subscription",    
            tr: "Abonelik",
        },
        "84": {
            en: "Extend or end your subscription",    
            tr: "Aboneliğinizi uzatın veya sonlandırın",
        },
        "85": {
            en: "Colors and fonts",    
            tr: "Renkler ve fontlar",
        },
        "86": {
            en: "Change colors and fonts on the customer app.",    
            tr: "Müşteri uygulaması üzerindeki renkleri ve fontları değiştirin.",
        },
        "87": {
            en: "To enable the Multi-language please select the base and target languages below and click enable.",    
            tr: "Çoklu-dil'i etkinleştirmek için bir varsayılan dil ve çevrilecek dilleri seçin ve etkinleştir'e klikleyin.",
        },
        "88": {
            en: "Select base language",    
            tr: "Varsayılan dili seçin",
        },
        "89": {
            en: "base language",    
            tr: "Varsayılan dil",
        },
        "90": {
            en: "select target languages",    
            tr: "hedef dilleri seçin",
        },
        "91": {
            en: "enable multi-language",    
            tr: "çoklu-dil'i etkinleştirin",
        },
        "92": {
            en: "Multi-language is enabled. You can change the languages using the form below.",    
            tr: "çoklu-dil etkin. Dilleri değiştirmek isterseniz aşağıdaki formu kullanın.",
        },
        "93": {
            en: "disable multi-language",    
            tr: "çoklu-dil'i kapatın",
        },
        "94": {
            en: "Primary color",    
            tr: "Birincil renk",
        },
        "95": {
            en: "Secondary color",    
            tr: "ikincil renk",
        },
        "96": {
            en: "Primary font",    
            tr: "Birincil font",
        },
        "97": {
            en: "Secondary font",    
            tr: "ikincil font",
        },
        "98": {
            en: "Primary text color",    
            tr: "Birincil metin rengi",
        },
        "99": {
            en: "Secondary text color",    
            tr: "ikincil metin rengi",
        },
        "100": {
            en: "Background color",    
            tr: "Arkaplan rengi",
        },
        "101": {
            en: "Choose subscription package",    
            tr: "Abonelik paketini seçin",
        },
        "102": {
            en: "Subscription",    
            tr: "Abonelik",
        },
        "103": {
            en: "You are subscribed. Your next renewal date is:",    
            tr: "Aboneliğiniz devam ediyor. Bir sonraki yenileme tarihi:",
        },
        "104": {
            en: "Days left until your trial end:",    
            tr: "Denemenizin bitmesine kalan gün:",
        },
        "105": {
            en: "Subscribe now!",    
            tr: "Abone olun",
        },
        "106": {
            en: "Your trial or subscription has expired.",    
            tr: "Deneme lisansınız veya aboneliğiniz sona erdi",
        },
        "107": {
            en: "Pay with credit card",    
            tr: "Kredi kartı ile ödeme",
        },
        "108": {
            en: "Pay later",    
            tr: "Sonradan ödeme",
        },
        "109": {
            en: "Pay at table",    
            tr: "Masada öde",
        },
        "110": {
            en: "Currency",    
            tr: "Para birimi",
        },
        "111": {
            en: "Customer calling",    
            tr: "Müşteri çağırıyor",
        },
        "112": {
            en: "Paynet configuration",    
            tr: "Paynet ayarları",
        },
        "113": {
            en: "Search by table no",    
            tr: "Masa numarası ile arayın",
        },
        "114": {
            en: "Are you sure you want to delete this row?",    
            tr: "Silmek istediğinize emin misiniz?",
        },
        "115": {
            en: "Add category",    
            tr: "Kategori ekle",
        },
        "116": {
            en: "Delete",    
            tr: "Sil",
        },
        "117": {
            en: "Edit",    
            tr: "Değiştir",
        },
        "118": {
            en: "Move down",    
            tr: "Aşağı",
        },
        "119": {
            en: "Move up",    
            tr: "Yukarı",
        },
        "120": {
            en: "Getting categories",    
            tr: "Kategoriler getiriliyor",
        },
        "121": {
            en: "Mark as paid",    
            tr: "Ödendi",
        },
        "122": {
            en: "Have you got the payment?",    
            tr: "Ödemeyi aldınız mı?",
        },
        "123": {
            en: "OK",    
            tr: "Tamam",
        },
        "124": {
            en: "New order notification",    
            tr: "Yeni sipariş uyarısı",
        },
        "125": {
            en: "Enable notifications to get visual warning when a new order received",    
            tr: "Yeni bir sipariş geldiğinde görsel bir uyarı alabilmek için bildirimleri etkinleştirin",
        },
        "126": {
            en: "Enable",    
            tr: "Etkinleştir",
        },
        "127": {
            en: "Enable",    
            tr: "Etkinleştir",
        },
        "128": {
            en: `You have not enabled new order notifications. To enable first click the "Enable" button then click "Allow" button on the second prompt.`,    
            tr: `Yeni sipariş uyarısını henüz etkinleştirmemişsiniz. Ekinleştirmek için önce aşağıdaki "Etkinleştir" butonuna sonra da gelecek uyarı üzerinde "İzin ver" butonuna klikleyiniz`,
        },
        "129": {
            en: `You have disabled new order notifications. To enable please first click the lock icon on the address bar as seen on the picture below. Than click "Ask (default)" and refresh the page.`,    
            tr: `Yeni sipariş uyarısını kapatmışsınız. Açmak için önce aşağıdaki resimde olduğu gibi adres çubuğundaki kilit ikonuna klikleyin, sonra açılan ekranda "Sor (varsayılan)" 'a klilkledikten sonra sayfayı güncelleyin`,
        },
        "130": {
            en: `You have enabled new order notifications. You should be receiving push notifications similar to below when a new order is received.`,    
            tr: `Yeni sipariş bildirimleri açık durumda. Yeni bir sipariş geldiginde aşağıdaki resimde olduğu gibi bildirim alıyor olmanız gerekir.`,
        },

    }


    const translateGuiElement = (textNo) => {

        return (translations[textNo][globalContext.globalState.selectedGuiLanguage]);
    }

    return [translateGuiElement];
}
